import { GameLobby } from "@/features/rooms/components/GameLobby.tsx";

export const GeoLobby = (
  { user }: {
    user?: {
      id: string;
      reservedRooms?: any[];
      isAnonymous?: boolean;
      name?: string;
    };
  },
) => {
  return (
    <GameLobby
      title="GEO PUZZLE"
      description="Race against friends or go head-to-head in a battle of geography knowledge."
      wsUrl="/ws/geo"
      createUrl="/api/geo/rooms"
      joinUrlPrefix="/geo"
      user={user}
      buttonText="Start New Game"
      showReserved={true}
    />
  );
};
